// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3XsJn","title":"Info_title__25c8o","selects":"Info_selects__ZF7qR","requiredAsterisk":"Info_requiredAsterisk__FZskB"};